import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Projets.css';

import projet1Image1 from '../assets/projet1_image1.png';
import projet2Image1 from '../assets/projet2_image1.png';
import projet2Image2 from '../assets/projet2_image2.png';
import projet3Image1 from '../assets/projet3_image1.png';
import projet3Image2 from '../assets/projet3_image2.png';
import projet4Image1 from '../assets/projet4_image1.png';
import projet4Image2 from '../assets/projet4_image2.png';
import projet4Image3 from '../assets/projet4_image3.png';
import projet5Image1 from '../assets/projet5_image1.png';
import projet5Image2 from '../assets/projet5_image2.png';
import projet5Image3 from '../assets/projet5_image3.png';
import projet6Image1 from '../assets/projet6_image1.png';
import projet6Image2 from '../assets/projet6_image2.png';
import projet6Image3 from '../assets/projet6_image3.png';
import projet7Image1 from '../assets/projet7_image1.png';
import projet8Image1 from '../assets/projet8_image1.png';
import projet9Image1 from '../assets/projet9_image1.png';
import projet9Image2 from '../assets/projet9_image2.png';

function Projets() {
  const navigate = useNavigate();

  const projets = [
    {
      id: 1,
      titre: 'Portfolio React',
      description:
        "Création d’un portfolio moderne et interactif avec React, permettant de présenter mes projets, mes compétences et mon parcours de manière claire, dynamique et professionnelle.",
      images: [projet1Image1],
      technologies: ['React', 'CSS', 'React Router', 'JavaScript'],
      apports: [
        'Maitrise des composants React',
        "Gestion de l'état avec useState et useEffect",
        "Structuration d'un projet web professionnel",
        'Création de composants réutilisables',
        'Mise en page responsive avec Flexbox et CSS Grid',
        'Utilisation de bibliothèques tierces comme react-router-dom'
      ],
      contenuDetail: {
        contexte:
          "Ce projet avait pour objectif de me créer une vitrine professionnelle en ligne afin de présenter mon profil, mes compétences techniques ainsi que les différents projets réalisés durant ma formation et mes expériences personnelles.",
        objectifs: [
          'Construire un site moderne, fluide et agréable à parcourir',
          'Mettre en avant mes projets de manière structurée',
          'Créer une interface responsive adaptée aux mobiles et ordinateurs',
          'Découvrir plus en profondeur l’écosystème React'
        ],
        realisations: [
          "Création d'une architecture claire avec séparation des composants",
          "Ajout d'une navigation fluide entre les différentes pages du portfolio",
          "Mise en place d'une galerie de projets avec aperçu visuel",
          "Travail sur l'identité visuelle, les espacements, les animations et l’ergonomie générale"
        ],
        difficultes:
          "Le principal défi a été de trouver un équilibre entre un design moderne et une structure simple à maintenir. J’ai également dû apprendre à mieux organiser les composants et à penser l’interface comme un vrai produit utilisateur.",
        resultat:
          "Le résultat est un portfolio fonctionnel, évolutif et entièrement personnalisable, que je peux faire évoluer au fil de mes nouvelles compétences et projets.",
        competences: [
          'Développement front-end',
          'React et hooks',
          'Responsive design',
          'Organisation de projet',
          'UI / UX de base'
        ]
      }
    },
    {
      id: 2,
      titre: "Site d'E-commerce sous Laravel",
      description:
        "Développement d’un site e-commerce complet sous Laravel avec gestion des produits, utilisateurs, commandes et tableau de bord administrateur.",
      images: [projet2Image1, projet2Image2],
      technologies: ['Laravel', 'PHP', 'MySQL', 'Blade', 'Apache'],
      apports: [
        "Création d'une architecture MVC avec Laravel",
        'Intégration de bases de données relationnelles avec MySQL',
        "Implémentation de fonctionnalités avancées comme l’authentification, les rôles administrateurs et le panier",
        'Gestion des migrations et des relations entre tables avec Eloquent ORM',
        "Déploiement sur un serveur web et configuration de l'environnement"
      ],
      contenuDetail: {
        contexte:
          "Ce projet avait pour but de concevoir une boutique en ligne complète à l’aide du framework Laravel. L’objectif était de reproduire les fonctionnalités principales d’un site e-commerce professionnel.",
        objectifs: [
          'Mettre en place un catalogue de produits',
          'Permettre aux utilisateurs de créer un compte et se connecter',
          'Gérer un panier et un processus de commande',
          'Créer un espace administrateur pour gérer les produits et les stocks'
        ],
        realisations: [
          'Développement du back-end avec Laravel en suivant le modèle MVC',
          'Création des tables et relations avec migrations et Eloquent',
          'Gestion des comptes utilisateurs, rôles et permissions',
          'Développement des pages de catalogue, détail produit, panier et commandes',
          "Mise en place d'une interface d'administration pour la gestion du contenu"
        ],
        difficultes:
          "La principale difficulté a été de bien structurer les relations entre les différentes entités, comme les utilisateurs, les produits, les catégories et les commandes. Il fallait aussi penser à la sécurité, à la validation des formulaires et à la cohérence du flux utilisateur.",
        resultat:
          "Ce projet m’a permis d’acquérir une vraie vision d’ensemble d’une application web complète, en combinant logique métier, gestion de données, interface utilisateur et administration.",
        competences: [
          'Laravel',
          'Architecture MVC',
          'Base de données relationnelle',
          'Gestion des utilisateurs',
          'Développement web full stack'
        ]
      }
    },
    {
      id: 3,
      titre: "Site d'E-commerce avec Prestashop (Provence-Harmonie)",
      description:
        "Développement et mise en ligne d’un site e-commerce fonctionnel pour la boutique Provence-Harmonie, avec personnalisation du thème et intégration des produits.",
      images: [projet3Image1, projet3Image2],
      technologies: ['Prestashop', 'PHP', 'MySQL', 'Serveur mutualisé', 'SEO'],
      apports: [
        'Apprentissage et maîtrise de Prestashop pour la création de boutiques en ligne',
        'Personnalisation de thèmes et gestion des modules Prestashop',
        'Gestion de la mise en ligne sur un serveur mutualisé',
        'Résolution des problèmes liés aux mises à jour et aux extensions',
        'Analyse des performances et optimisation pour le référencement SEO'
      ],
      contenuDetail: {
        contexte:
          "Ce projet consistait à participer à la création et à la mise en ligne d’une boutique en ligne réelle. Il s’agissait d’un projet concret orienté métier, avec des contraintes proches de celles rencontrées en entreprise.",
        objectifs: [
          'Mettre en place une boutique e-commerce opérationnelle',
          'Intégrer les produits et organiser leur présentation',
          'Adapter le thème à l’identité visuelle voulue',
          'Assurer une mise en ligne stable et exploitable'
        ],
        realisations: [
          'Installation et configuration initiale de Prestashop',
          'Personnalisation de certaines parties du thème',
          'Ajout et organisation du catalogue produit',
          'Réglages liés aux modules, aux menus et à la navigation',
          'Travail sur la cohérence visuelle et le référencement naturel'
        ],
        difficultes:
          "Les difficultés principales concernaient la compatibilité de certains modules, les limites liées à l’hébergement mutualisé, ainsi que l’adaptation du thème sans casser la structure initiale de Prestashop.",
        resultat:
          "Le site a pu être mis en ligne et utilisé comme boutique réelle. Ce projet m’a permis de mieux comprendre les besoins concrets d’un site marchand, ainsi que les compromis entre personnalisation, stabilité et simplicité de maintenance.",
        competences: [
          'Prestashop',
          'Intégration e-commerce',
          'Mise en ligne',
          'Résolution de problèmes',
          'SEO technique de base'
        ]
      }
    },
    {
      id: 4,
      titre: 'Interpréteur de Code Assembleur en C++ en groupe',
      description:
        "Création d’un interpréteur capable d’exécuter des programmes assembleur, dans le cadre d’un projet de groupe mené avec une organisation agile.",
      images: [projet4Image1, projet4Image2, projet4Image3],
      technologies: ['C++', 'GitLab', 'Méthodes agiles', 'Tests unitaires'],
      apports: [
        'Collaboration en équipe dans un cadre méthodologique agile',
        'Gestion des tâches via GitLab',
        "Conception d’algorithmes complexes pour traduire et exécuter du code assembleur",
        'Manipulation avancée de structures de données',
        'Tests unitaires et intégration continue',
        'Rédaction de documentation technique',
        'Présentation orale du projet devant un jury'
      ],
      contenuDetail: {
        contexte:
          "Ce projet de groupe consistait à développer un interpréteur capable de lire, analyser et exécuter un pseudo-code assembleur. Il s’agissait d’un projet très formateur sur la logique algorithmique, la rigueur de développement et le travail d’équipe.",
        objectifs: [
          'Comprendre le fonctionnement d’un langage bas niveau',
          'Concevoir un interpréteur robuste',
          'Répartir les tâches efficacement dans une équipe',
          'Produire un rendu exploitable techniquement et présentable à l’oral'
        ],
        realisations: [
          'Analyse de la syntaxe des instructions assembleur',
          'Création de la logique d’exécution des instructions',
          'Gestion de la mémoire simulée, des registres et des opérations',
          'Mise en place d’un suivi de projet avec GitLab et répartition des tâches',
          'Rédaction de la documentation et préparation de la soutenance'
        ],
        difficultes:
          "La complexité principale venait de la logique pure du projet. Il fallait être très rigoureux sur le comportement attendu de chaque instruction, tout en coordonnant efficacement le travail en groupe.",
        resultat:
          "Ce projet m’a permis de progresser en algorithmique, en C++, en débogage et en gestion collaborative. C’est aussi un projet marquant car il demandait à la fois de la technique, de la méthode et de la communication.",
        competences: [
          'C++',
          'Algorithmique',
          'Travail en équipe',
          'Gestion de version',
          'Documentation technique',
          'Présentation orale'
        ]
      }
    },
    {
      id: 5,
      titre: "Application mobile à thème 'Le Petit Prince'",
      description:
        "Développement d’une application mobile orientée parents d’élèves, inspirée de l’univers du Petit Prince, pour consulter des informations scolaires et des contenus de classe.",
      images: [projet5Image1, projet5Image2, projet5Image3],
      technologies: ['Ionic', 'Firebase', 'SQLite', 'Mobile UI'],
      apports: [
        "Création d’une interface utilisateur intuitive",
        'Gestion des données avec SQLite',
        "Ajout d’un menu de navigation entre les sections",
        "Conception graphique en respectant l’univers visuel du Petit Prince",
        'Tests d’affichage sur différents écrans',
        "Utilisation de Firebase pour l’authentification et les notifications"
      ],
      contenuDetail: {
        contexte:
          "L’objectif de cette application était de proposer un outil simple et accessible aux parents d’élèves afin de centraliser les informations utiles liées à la vie scolaire, dans une interface douce et accueillante.",
        objectifs: [
          'Créer une application mobile claire et intuitive',
          'Permettre aux parents d’accéder rapidement aux informations',
          'Respecter un univers graphique cohérent et identifiable',
          'Découvrir les contraintes du développement mobile'
        ],
        realisations: [
          'Création de plusieurs écrans de consultation',
          'Organisation des contenus par section',
          'Travail sur le design et l’identité visuelle autour du thème du Petit Prince',
          'Stockage local de certaines données',
          'Connexion à des services comme Firebase pour certaines fonctionnalités'
        ],
        difficultes:
          "Le défi principal était de créer une interface lisible et rassurante pour un public non technique. Il fallait aussi veiller à la cohérence graphique tout en gardant une navigation fluide.",
        resultat:
          "Ce projet m’a permis d’aborder la logique d’une application mobile réelle, avec une réflexion plus poussée sur l’utilisateur final, les usages mobiles et la présentation du contenu.",
        competences: [
          'Développement mobile',
          'Organisation UX',
          'Stockage local',
          'Services cloud',
          'Travail graphique'
        ]
      }
    },
    {
      id: 7,
      titre: 'Agenda / gestionnaire de tâches',
      description:
        "Création d’une application de gestion de tâches permettant d’ajouter, supprimer, filtrer et suivre l’état d’avancement des tâches dans une interface simple et fonctionnelle.",
      images: [projet7Image1],
      technologies: ['Vue.js', 'JavaScript', 'CSS', 'localStorage'],
      apports: [
        "Maitrise des composants Vue.js et de la gestion de l'état",
        "Utilisation des directives et des computed properties",
        'Gestion des événements et des interactions utilisateur',
        'Mise en page responsive',
        'Utilisation de localStorage pour stocker les données localement',
        'Création d’une interface utilisateur interactive'
      ],
      contenuDetail: {
        contexte:
          "Ce projet avait pour but de développer une petite application utile du quotidien, centrée sur la gestion de tâches. Il s’agissait d’un projet parfait pour travailler la logique front-end et les interactions utilisateur.",
        objectifs: [
          'Permettre la création et la suppression de tâches',
          'Ajouter des filtres pour améliorer la lisibilité',
          'Conserver les données localement',
          'Créer une interface simple, rapide et efficace'
        ],
        realisations: [
          'Ajout dynamique de tâches',
          'Suppression et modification d’état',
          'Filtrage des tâches selon leur statut',
          'Stockage local via localStorage',
          'Travail sur une interface épurée et pratique'
        ],
        difficultes:
          "Le principal enjeu était de garder une logique simple mais propre, tout en assurant une bonne expérience utilisateur. Il fallait aussi bien gérer la persistance locale et les mises à jour visuelles.",
        resultat:
          "Le résultat final est une application légère mais fonctionnelle, qui m’a permis de mieux comprendre la logique réactive de Vue.js et la gestion des données côté client.",
        competences: [
          'Vue.js',
          'Réactivité',
          'Manipulation du DOM',
          'Gestion d’état simple',
          'Stockage local'
        ]
      }
    },
    {
      id: 8,
      titre: 'Système de messagerie interne avec machines virtuelles',
      description:
        "Développement et déploiement d’un système de messagerie interne sécurisé sur un réseau virtuel simulé, avec serveur mail, DNS et clients de messagerie.",
      images: [projet8Image1],
      technologies: ['Linux', 'Postfix', 'Dovecot', 'DNS', 'VirtualBox/VMware', 'Thunderbird'],
      apports: [
        'Mise en place et configuration de machines virtuelles',
        "Configuration réseau avancée avec adressage IP statique et DHCP",
        "Déploiement d'un serveur de messagerie Postfix/Dovecot sous Linux",
        'Gestion des protocoles SMTP, IMAP et POP3',
        "Implémentation d'un serveur DNS",
        'Sécurisation du serveur avec SSL/TLS',
        'Tests de communication entre clients de messagerie'
      ],
      contenuDetail: {
        contexte:
          "Ce projet visait à simuler une infrastructure de messagerie d’entreprise dans un environnement virtualisé. Il mettait l’accent sur les services réseau, l’administration système et la communication entre plusieurs machines.",
        objectifs: [
          'Créer un réseau interne cohérent entre plusieurs machines virtuelles',
          'Déployer un serveur mail fonctionnel',
          'Permettre l’envoi et la réception de messages entre utilisateurs',
          'Sécuriser les échanges et assurer la résolution réseau'
        ],
        realisations: [
          'Création de plusieurs machines virtuelles',
          'Configuration réseau et tests de connectivité',
          'Installation et configuration de Postfix et Dovecot',
          'Ajout d’un serveur DNS pour la résolution interne',
          'Validation des échanges via des clients de messagerie'
        ],
        difficultes:
          "Les difficultés venaient surtout du diagnostic réseau, de la compréhension des interactions entre les différents services et de la configuration correcte des protocoles de messagerie.",
        resultat:
          "Ce projet m’a permis d’approfondir la logique d’une infrastructure système et réseau complète, et de mieux comprendre la relation entre les services, les protocoles et la sécurité.",
        competences: [
          'Administration Linux',
          'Réseau',
          'Services mail',
          'Virtualisation',
          'Diagnostic technique'
        ]
      }
    },
    {
      id: 9,
      titre: "Mise en place d'un serveur Linux multi-services",
      description:
        "Installation et configuration d’un serveur Debian 12 destiné à héberger un portfolio web ainsi qu’une multitude de services personnels auto-hébergés.",
      images: [projet9Image1, projet9Image2],
      technologies: ['Debian 12', 'Docker', 'Portainer', 'Apache2', 'MySQL', 'Bind9', 'OpenVPN', 'AdGuard Home'],
      apports: [
        "Utilisation de Portainer et Docker pour l'installation et la gestion des conteneurs",
        "Installation et configuration d'un serveur web Apache2",
        "Mise en place d'un serveur de base de données MySQL",
        "Configuration d'un serveur de messagerie Postfix/Dovecot",
        "Installation et configuration d'un serveur DNS Bind9",
        "Configuration d'un serveur VPN OpenVPN",
        "Mise en place d'un serveur de sauvegarde avec Rsync",
        'Sécurisation des services avec SSL/TLS',
        "Configuration d'un pare-feu",
        'Surveillance des services',
        "Installation d'AdGuard Home"
      ],
      contenuDetail: {
        contexte:
          "Ce projet personnel consistait à mettre en place un serveur Linux polyvalent capable d’héberger mon portfolio ainsi que différents services utiles pour mon usage personnel. Il s’agissait d’un projet transversal mêlant système, réseau, sécurité et hébergement.",
        objectifs: [
          'Héberger mon portfolio sur un environnement maîtrisé',
          'Centraliser plusieurs services sur une seule machine',
          'Découvrir et pratiquer l’auto-hébergement',
          'Renforcer la sécurité et la supervision du serveur'
        ],
        realisations: [
          'Installation et configuration de Debian 12',
          'Déploiement de services via Docker et Portainer',
          'Hébergement web avec Apache2',
          'Mise en place de services réseau et système complémentaires',
          'Ajout de mesures de sécurité et de surveillance',
          'Organisation du serveur pour un usage évolutif'
        ],
        difficultes:
          "Le principal défi a été de faire fonctionner le serveur dans un environnement contraint, notamment à cause des restrictions imposées par Starlink, qui bloque de nombreux ports et services. Même avec un VPS, la mise en place s’est révélée complexe et instable, au point de compromettre la viabilité du projet sur cette infrastructure. J’ai finalement dû envisager une autre approche pour pouvoir le mener à terme.",
        resultat:
          "Ce projet m’a permis de développer une vraie autonomie sur Linux et dans l’auto-hébergement. C’est un projet très complet qui démontre ma capacité à gérer un environnement serveur concret.",
        competences: [
          'Administration Linux',
          'Docker',
          'Hébergement web',
          'Services réseau',
          'Sécurité système',
          'Auto-hébergement'
        ]
      }
    }
  ];

  const [selectedProject, setSelectedProject] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setCurrentImageIndex(0);
  };

  const closeFullscreen = () => {
    setSelectedProject(null);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    if (!selectedProject) return;
    setCurrentImageIndex((prevIndex) =>
      prevIndex + 1 < selectedProject.images.length ? prevIndex + 1 : 0
    );
  };

  const prevImage = () => {
    if (!selectedProject) return;
    setCurrentImageIndex((prevIndex) =>
      prevIndex - 1 >= 0 ? prevIndex - 1 : selectedProject.images.length - 1
    );
  };

  const handleSeeDetails = () => {
    if (!selectedProject) return;

    navigate(`/projet/${selectedProject.id}`, {
      state: {
        project: selectedProject
      }
    });
  };

  return (
    <div className="projets-container">
      <h1 className="projets-title">Mes Projets</h1>

      <div className="projets-grid">
        {projets.map((projet) => (
          <article
            key={projet.id}
            className="projet-card"
            onClick={() => handleProjectClick(projet)}
          >
            <div className="projet-image-wrapper">
              <img
                src={projet.images[0]}
                alt={`Aperçu de ${projet.titre}`}
                className="projet-image"
              />
            </div>

            <div className="projet-card-content">
              <h3>{projet.titre}</h3>
              <p>{projet.description}</p>
              <span className="projet-link">Cliquer pour voir le projet</span>
            </div>
          </article>
        ))}
      </div>

      {selectedProject && (
        <div className="fullscreen-overlay" onClick={closeFullscreen}>
          <div
            className="fullscreen-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-icon" onClick={closeFullscreen}>
              ✕
            </button>

            {selectedProject.images.length > 1 && (
              <>
                <button
                  className="nav-button prev-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    prevImage();
                  }}
                >
                  ‹
                </button>

                <button
                  className="nav-button next-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    nextImage();
                  }}
                >
                  ›
                </button>
              </>
            )}

            <img
              src={selectedProject.images[currentImageIndex]}
              alt={`${selectedProject.titre} - Image ${currentImageIndex + 1}`}
              className="fullscreen-image"
            />

            <div className="fullscreen-body">
              <span className="image-counter">
                {currentImageIndex + 1} / {selectedProject.images.length}
              </span>

              <h2>{selectedProject.titre}</h2>
              <p>{selectedProject.description}</p>

              {selectedProject.technologies && (
                <div className="projet-techno">
                  {selectedProject.technologies.map((tech, index) => (
                    <span key={index} className="tech-badge">
                      {tech}
                    </span>
                  ))}
                </div>
              )}

              <ul className="projet-apports">
                {selectedProject.apports.map((apport, index) => (
                  <li key={index}>{apport}</li>
                ))}
              </ul>

              <div className="fullscreen-actions">
                <button
                  className="detail-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSeeDetails();
                  }}
                >
                  Voir en détail
                </button>

                <button onClick={closeFullscreen} className="close-btn">
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Projets;